{
    "ChannelCode": "Code",
    "Components": {
        "MeetingEnd": {
            "FeedbackConfirmation": {
                "ExploreMoreFeatures": "Weitere Funktionen entdecken",
                "ThanksMessage": "Danke, dass Sie dabei waren,",
                "WorkingMessage": "wir hoffen, die Übersetzung hat die Veranstaltung für Sie noch besser gemacht."
            },
            "FeedbackForm": {
                "FeedbackQuestion": "Wie war die Übersetzungsqualität?",
                "SessionClosedMessage": "Die Live-Übersetzung ist nun beendet.",
                "ThankYouMessage": "Wir hoffen, das hat geholfen!"
            }
        }
    },
    "Continue": "Fortfahren",
    "Control": {
        "Original": "Original",
        "Spacing": "Abstand",
        "TextSize": "Textgröße",
        "Tts": "TTS"
    },
    "Download": "Herunterladen",
    "Idle": "Leerlauf",
    "Join": "Beitreten",
    "LanguageSettings": "Sprache",
    "Live": "Läuft",
    "Loading": {
        "Entering": "Kanal wird betreten",
        "Joining": "Kanal wird beigetreten"
    },
    "OK": "OK",
    "Pages": {
        "Home": {
            "EnterEventCodeMessage": "Bitte geben Sie den Kanalcode ein.",
            "InputPlaceholder": "Kanalcode eingeben",
            "Title": "Seien Sie dabei. Verstehen Sie alles."
        },
        "SelectLanguage": {
            "SearchEmpty": "Keine passende Sprache",
            "SearchPlaceholder": "Sprache suchen",
            "Title": "Wählen Sie Ihre Übersetzungssprache"
        }
    },
    "Pane": {
        "CatchUp": "Zum Neuesten",
        "Source": "Original",
        "Translation": "Übersetzung",
        "Tts": "Sprachausgabe",
        "TtsShort": "TTS"
    },
    "Share": "Teilen",
    "SpeechSpeed": "Sprechgeschwindigkeit",
    "Start": "Starten",
    "Submit": "Senden",
    "Tips": {
        "Error": {
            "Channel": {
                "LimitExceeded": "Dieser Kanal hat sein Verbindungslimit erreicht."
            }
        },
        "Icon": {
            "ScrollToBottom": "Zurück zum Neuesten",
            "ShareLink": "Link teilen",
            "SpeechRate": "Wiedergabegeschwindigkeit einstellen"
        }
    },
    "Toast": {
        "LanguageChanged": "Übersetzungssprache: {lang}",
        "LinkCopied": "Link kopiert",
        "SourceOff": "Original ausgeblendet",
        "SourceOn": "Original eingeblendet",
        "TtsOff": "Sprachausgabe aus",
        "TtsOn": "Sprachausgabe an"
    },
    "Transcript": {
        "Start": "Anfang des Transkripts"
    },
    "tutorialPage": {
        "downloadOverlay": {
            "originText": "Originaltext",
            "summary": "Zusammenfassung",
            "transcript": "Transkripte"
        },
        "translationLanguage": {
            "title": "Übersetzungssprache"
        }
    }
}
